// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"f45bf193","677":"fd47212d"}[chunkId] + ".chunk.css";
};